import React, { useState, useEffect } from 'react';
import Form from './components/Form'
import ImagesList from './components/ImagesList'

function App() {

  const [search, saveSearch] = useState('');
  const [images, saveImages] = useState([]);
  const [current_page, saveCurrentPage] = useState(1);
  const [total_pages, saveTotalPages] = useState(1);


  useEffect(() => {
    const consultAPI = async () => {
      if (search === '') return;

      const imagesPerPage = 30;
      const key = '15909221-35245aa73081352d0e87ada0f'
      const url = `https://pixabay.com/api/?key=${key}&q=${search}&per_page=${imagesPerPage}&page=${current_page}`

      const response = await fetch(url);
      const result = await response.json();

      // console.log(result.hits);
      saveImages(result.hits);
      // saveSearch(result);

      // calcular el total de paginas 
      const calculateTotalPages = Math.ceil(result.totalHits / imagesPerPage);
      saveTotalPages(calculateTotalPages);

      const jumbotron = document.querySelector(".jumbotron");
      jumbotron.scrollIntoView({ behavior: 'smooth' });

    }
    consultAPI();
  }, [search, current_page]);

  const pageBefore = () => {
    const new_current_page = current_page - 1;
    if (new_current_page === 0) return;
    saveCurrentPage(new_current_page);
  }
  const pageAfter = () => {
    const new_current_page = current_page + 1;
    if (new_current_page > total_pages) return;
    saveCurrentPage(new_current_page);
  }

  return (
    <div className="container">
      <div className="jumbotron">
        <p className="lead text-center">
          Buscador de imágenes
          </p>
        <Form
          saveSearch={saveSearch}
        />
      </div>
      <div className="row justify-content-center">
        <ImagesList
          images={images}
        />
        {(current_page === 1) ? null :
          (
            <button
              type="button"
              className="bbtn btn-info mr-1 mb-5"
              onClick={pageBefore}
            >
              &laquo; Anterior
            </button>
          )}

        {(current_page === total_pages) ? null : (
          <button
            type="button"
            className="bbtn btn-info mb-5"
            onClick={pageAfter}
          >
            Siguiente &raquo;
          </button>
        )}

      </div>
    </div>
  );
}

export default App;
